<mat-dialog-content>
    <span mat-dialog-title style="margin: 0px">Ihre Nachricht</span>
    <div>
        <mat-icon
            style="cursor: pointer"
            [matMenuTriggerFor]="textmenu"
            #menuTrigger="matMenuTrigger"
            (click)="$event.stopPropagation()"
            >library_add</mat-icon
        >
        <mat-menu #textmenu="matMenu">
            <button
                mat-menu-item
                (click)="addText(index)"
                *ngFor="let index of textNummers; let i = index"
                [matTooltip]="
                    ((stateService.sharedSettings | async)?.savedNotizTexts &&
                        (stateService.sharedSettings | async)?.savedNotizTexts[index]) ||
                    'Kein Text'
                "
                style="height: 30px; display: flex; align-items: center"
            >
                {{ index }}:
                <span *ngIf="(stateService.sharedSettings | async)?.savedNotizTexts">
                    {{ (stateService.sharedSettings | async)?.savedNotizTexts[index] || 'Kein Text' }}
                </span>
                <span *ngIf="!(stateService.sharedSettings | async)?.savedNotizTexts"> Kein Text </span>
            </button>
        </mat-menu>
        <mat-icon
            [class.grey]="!data.comment.text"
            style="cursor: pointer"
            [matMenuTriggerFor]="savemenu"
            (click)="$event.stopPropagation()"
            >save</mat-icon
        >
        <mat-menu #savemenu="matMenu">
            <button
                mat-menu-item
                (click)="saveText(index)"
                *ngFor="let index of textNummers; let i = index"
                [matTooltip]="
                    ((stateService.sharedSettings | async)?.savedNotizTexts &&
                        (stateService.sharedSettings | async)?.savedNotizTexts[index]) ||
                    'Kein Text'
                "
                style="height: 30px; display: flex; align-items: center"
            >
                {{ index }}:
                <span *ngIf="(stateService.sharedSettings | async)?.savedNotizTexts">
                    {{ (stateService.sharedSettings | async)?.savedNotizTexts[index] || 'Kein Text' }}
                </span>
                <span *ngIf="!(stateService.sharedSettings | async)?.savedNotizTexts"> Kein Text </span>
            </button>
        </mat-menu>
    </div>

    <mat-form-field class="full-width" style="width: 100%">
        <textarea matInput placeholder="Text" rows="8" maxrows="50" [(ngModel)]="data.comment.text"></textarea>
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-flat-button mat-button mat-dialog-close tabindex="-1"><span>Abbrechen</span></button>
    <button color="primary" mat-flat-button mat-button [disabled]="!data.comment.text" (click)="save()" type="submit">
        <span>Speichern</span>
    </button>
</mat-dialog-actions>
